import urlResolver from 'edrolo/utils/URLResolver';
import useSWR from 'swr';

export interface Course {
  course_id: number;
  course_title: string;
  topics: Topic[];
  // TBC: decide what we want to do with exams/question sets attached directly to the course
  // TOL: including 'em for when topic == 'all' could be one way to do it
  question_sets: QuestionSet[] | [];
  exams: Exam[] | [];
}

// TODO: merge these two interfaces into one now that we want to show questions regardless of EM/Question Set exams
export interface QuestionSet {
  question_set_id: number;
  question_set_title: string;
}
export interface Exam {
  id: number;
  title: string;
}
export interface Lesson {
  lesson_id: number;
  lesson_title: string;
}
export interface Topic {
  topic_id: number;
  topic_title: string;
  question_sets: QuestionSet[] | [];
  exams: Exam[] | [];
  lessons: Lesson[] | [];
}

export const useQuestionSets = (courseId?: number | null) => {
  const shouldFetch = courseId !== null && courseId !== undefined;
  const url = shouldFetch
    ? urlResolver.reverse('api:topic-question-sets-for-course', { courseId })
    : null;

  const { data, error, isLoading } = useSWR(url, {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });

  return {
    data: data || { topics: [], exams: [], question_sets: [] },
    isLoading: shouldFetch ? isLoading : false,
    error: shouldFetch ? error : undefined,
  };
};
